import { render } from "./RecommendedProperties.vue?vue&type=template&id=60bde24a&scoped=true"
import script from "./RecommendedProperties.vue?vue&type=script&lang=js"
export * from "./RecommendedProperties.vue?vue&type=script&lang=js"

import "./RecommendedProperties.vue?vue&type=style&index=0&id=60bde24a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bde24a"]])

export default __exports__